export const CLIP_LIBRARY = {
    clips: [
        {
            clipUrl: 'https://www.twitch.tv/daameer/clip/SlickShortHornetAMPEnergy-a6zxFLiNYqtVexF1',
            clipTitle: 'Locked out of Tomatoes',
            clipDate: new Date('2026-09-30T00:00:00Z'),
            streamerName: 'daameer',
            gameId: '693bad642f3a8ff742190144',
            postedToSocial: false,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/daameer/clip/CrepuscularEsteemedWhaleDoggo-wEE4sU4msGgYfnRu',
            clipTitle: 'Girelephant is born',
            clipDate: new Date('2026-09-30T00:00:00Z'),
            streamerName: 'daameer',
            gameId: '6a4443ab95150cffae4f482e',
            postedToSocial: false,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/GentlePowerfulChickenPoooound-RUS4N8TEcsHYa_Dp',
            clipTitle: "I'm not that simple!",
            clipDate: new Date('2026-08-17T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '6a4445679a8400bf1b9aae8d',
            postedToSocial: false,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/PleasantImportantLorisTooSpicy--BHAOx_zxVCw-lEM',
            clipTitle: 'My mental health is forked up',
            clipDate: new Date('2026-08-13T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: false,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/BlindingDarlingCurlewSoBayed-GjfGP9qRBld1eafv',
            clipTitle: 'Lifelong monogamy',
            clipDate: new Date('2026-08-13T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '6701bc6c35797c2928318643',
            postedToSocial: false,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/daameer/clip/PerfectResilientTofuDuDudu-3AJAleoWDskEPQK-',
            clipTitle: 'Batman',
            clipDate: new Date('2026-08-13T00:00:00Z'),
            streamerName: 'daameer',
            gameId: '693bad642f3a8ff742190144',
            postedToSocial: false,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/daameer/clip/MagnificentBoldMangoRaccAttack-DQh0ncjKguejo7ei',
            clipTitle: 'Double touch a penguin?',
            clipDate: new Date('2026-08-13T00:00:00Z'),
            streamerName: 'daameer',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: false,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/daameer/clip/PeacefulPiliableMoonCoolCat-MpLntXaFRxjjJ0eF',
            clipTitle: 'Time to go commando',
            clipDate: new Date('2026-08-13T00:00:00Z'),
            streamerName: 'daameer',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: false,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/CloudyGentleKleeFailFish-zYHrvRLdoafP-bca',
            clipTitle: 'Edgy & P get flushed',
            clipDate: new Date('2026-08-12T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '69c55319c9763aa207ae0fb2',
            postedToSocial: false,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/SwissHelpfulMartenShazBotstix-CVfSPyCGOVca0LEC',
            clipTitle: 'Miraculous Save',
            clipDate: new Date('2026-08-12T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '69c55319c9763aa207ae0fb2',
            postedToSocial: false,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/SuccessfulFamousDuckDoggo-DRa4dAC8gCIQcFJg',
            clipTitle: 'Kirsty Goes Against the Grain... and Wins!',
            clipDate: new Date('2026-08-12T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '69c55319c9763aa207ae0fb2',
            postedToSocial: false,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/CrepuscularAbnegateDonutKappaRoss-sDNX85lXMzX_bpla',
            clipTitle: 'There are two kinds of people in the world',
            clipDate: new Date('2026-08-11T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '6a3349523db03ba5ecbf1db2',
            postedToSocial: false,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/daameer/clip/DependableBlindingUdonDoritosChip-3Td3oDjqbUxnyPV6',
            clipTitle: 'Cosy Stripclub Soup',
            clipDate: new Date('2026-08-10T00:00:00Z'),
            streamerName: 'daameer',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: false,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/ExcitedDarlingSquidKAPOW-PGkC5aGhBMIVMMN-',
            clipTitle: 'ABBA draws something disturbing',
            clipDate: new Date('2026-08-10T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '6a4445679a8400bf1b9aae8d',
            postedToSocial: false,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/SarcasticPlumpHorseradishAMPEnergyCherry-y28G5a9P5QX8flM_',
            clipTitle: 'In all his cottontail glory',
            clipDate: new Date('2026-08-10T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '6a4443ab95150cffae4f482e',
            postedToSocial: false,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/HealthyEnticingPangolinDatBoi-D_BsftPaJzrBO0ta',
            clipTitle: 'So bad, but so good',
            clipDate: new Date('2026-08-10T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '6a3349523db03ba5ecbf1db2',
            postedToSocial: false,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/RoughSuperChowderRalpherZ-c-1DUH7Bf7gS577Y',
            clipTitle: "Don't get the chocolate donut",
            clipDate: new Date('2026-06-16T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/PrettyMagnificentKaleStrawBeary-A5qAyX1xzdaIRLOK',
            clipTitle: 'Edgy clued in to nudity',
            clipDate: new Date('2026-06-16T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '693bad642f3a8ff742190144',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/BeautifulLazySwallowArgieB8-0d3yv1uh0X2GI5K7',
            clipTitle: 'Care Bears go head first into dessert',
            clipDate: new Date('2026-06-15T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/SpinelessMoldyManateeAsianGlow-vxqnKq4Kle8ff3ql',
            clipTitle: 'Edgy with a generous gift',
            clipDate: new Date('2026-06-15T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '69c55319c9763aa207ae0fb2',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/daameer/clip/CrypticFrigidDuckDxCat-7AtBwOIHfBNXJwNv',
            clipTitle: "There's a first time for everything",
            clipDate: new Date('2026-06-08T00:00:00Z'),
            streamerName: 'daameer',
            gameId: '693bad642f3a8ff742190144',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/daameer/clip/DependableRichFalconDeIlluminati-QzlAxfMlC2sHCf0V',
            clipTitle: 'Penguins jailed driving',
            clipDate: new Date('2026-06-08T00:00:00Z'),
            streamerName: 'daameer',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/RenownedVictoriousCamelFeelsBadMan-rxgWWrwIaPdI6A21',
            clipTitle: 'No wonder gas prices are higher',
            clipDate: new Date('2026-06-08T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/PowerfulAttractiveIguanaSquadGoals-IyImP08LULhNqlCw',
            clipTitle: 'Thinking outside the pope hat',
            clipDate: new Date('2026-06-08T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/UnusualYawningRabbitRedCoat-UjiAXB12ERAroluu',
            clipTitle: 'Bunny babies blast by Edgy',
            clipDate: new Date('2026-06-08T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '69ac5a4510c9adc947dc1981',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/CourteousTrustworthyStarlingFunRun-QSUVHUy3WTLOMovJ',
            clipTitle: 'Edgy wiped out AGAIN',
            clipDate: new Date('2026-06-08T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '69c55319c9763aa207ae0fb2',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/NastyResoluteLadiesShadyLulu-ga_aAH11Jt162x3T',
            clipTitle: 'Blame the deep-state golf caddie',
            clipDate: new Date('2026-06-08T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/RepleteFilthyRadicchioNotATK-xqLS-vwhtrUvvVek',
            clipTitle: 'Honestly, all on the same page',
            clipDate: new Date('2026-06-08T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '6701bc6c35797c2928318643',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/CourteousAlertPheasantDxCat-HE4DCzVrxHmIFM4w',
            clipTitle: 'Who would play Edgy?',
            clipDate: new Date('2026-06-08T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '68016cb23f0914bff706b7ca',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/SpunkyMoistPheasantGivePLZ-Cgmyjd2--qTyK63Y',
            clipTitle: "Calling shenanigans on ABBA's win",
            clipDate: new Date('2026-06-08T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '69c55319c9763aa207ae0fb2',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/CrypticHelpfulRedpandaPermaSmug-HHcAW4rUMOjc1PP0',
            clipTitle: 'Zuck admits to affair with himself',
            clipDate: new Date('2026-06-08T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/SucculentCoyLorisDancingBaby-iTrv25-hk5di7FhS',
            clipTitle: 'Yubey trap',
            clipDate: new Date('2026-06-08T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '6701bc6c35797c2928318643',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/AssiduousFriendlyRadishTriHard-gH710eDe1sq9g8kN',
            clipTitle: 'Comic-Con leaving everyone tongue tied',
            clipDate: new Date('2026-06-08T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/PoliteLazyMouseCorgiDerp-diSgQ0hyjBSo16em',
            clipTitle: 'P fails to cool off Edgy',
            clipDate: new Date('2026-06-08T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '69c55319c9763aa207ae0fb2',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/ManlyProudRadicchioRiPepperonis-hzMFJ3dV1vCzwqKN',
            clipTitle: 'Payback is a...',
            clipDate: new Date('2026-06-08T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '69c55319c9763aa207ae0fb2',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/FrailAlertKuduCeilingCat-zXzGSfAAfzlDx3Bq',
            clipTitle: 'Dank edges out YooptyDoopty',
            clipDate: new Date('2026-06-07T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/StrongSteamyCasetteOhMyDog-zWZP2upkQ02wLWls',
            clipTitle: 'Where is the cream coming from?',
            clipDate: new Date('2026-06-07T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/ProductiveMistyPepperoniKappaClaus-ZeSbSVCOX949sL1u',
            clipTitle: 'Pig out on this disturbing dish',
            clipDate: new Date('2026-06-07T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/StupidSpoopyMagpieImGlitch-yjPjZ2rk-ZXXpeEM',
            clipTitle: 'Working steadily during business hours',
            clipDate: new Date('2026-06-07T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/daameer/clip/DirtyScaryPotatoCopyThis-yaxlRKrOXseNgsAE',
            clipTitle: 'Chocolate happy bed :)',
            clipDate: new Date('2026-06-08T00:00:00Z'),
            streamerName: 'daameer',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/CourteousTriumphantAnteaterDancingBaby-cDxkJOV8WflWy4il',
            clipTitle: "Jaykeraffe won't stop eating",
            clipDate: new Date('2026-05-18T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '69c55319c9763aa207ae0fb2',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/BlueEnticingPonyANELE-rPjlDYSimOz-m4OY',
            clipTitle: "Baby Yoda's Fart Box",
            clipDate: new Date('2026-05-18T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/StylishSlipperySparrowPanicVis-2Ypsj_dUsHG_IBJu',
            clipTitle: "Okiedokie's all-you-can-eat sushi",
            clipDate: new Date('2026-05-17T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/SpookyClearChoughEleGiggle-pEthb3x-LhPWNKTH',
            clipTitle: 'Just like it, but enlarged',
            clipDate: new Date('2026-05-17T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/EnticingKnottyEndiveFloof-0J0KWrndF2iH_bPC',
            clipTitle: 'Milking the competition',
            clipDate: new Date('2026-05-17T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: false,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/LuckyViscousWoodcockDogFace-UqZ4wGHby1Qm9tGH',
            clipTitle: "We Can't Do That!",
            clipDate: new Date('2026-04-06T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/UgliestWiseTroutBIRB-8xjHJyDOoWaex8BC',
            clipTitle: 'DOC WHAT IS THAT',
            clipDate: new Date('2026-04-06T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/DarkNeighborlyEggplantPraiseIt-RJ6IJK9zV1TJuHeC',
            clipTitle: 'NOT OKAY',
            clipDate: new Date('2026-04-06T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/IntelligentLazyBaguetteTTours-cJ_y3YJdbkJy5WX8',
            clipTitle: 'Red, White and... Blue Stuff?',
            clipDate: new Date('2026-04-06T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/TubularDarkCheesePogChamp-yg8EaCW_vQVxwsGu',
            clipTitle: 'P & Kinkie heal Poppy! (Edgy was right)',
            clipDate: new Date('2026-04-06T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '6921e33b0eef394c89845fb8',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/HomelyResourcefulOtterRitzMitz-4UJj-xLV1FFMoiVU',
            clipTitle: 'The Passion of the Pizza',
            clipDate: new Date('2026-04-06T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/AliveHomelyHawkHeyGuys-L32grFCh5jHrKKS1',
            clipTitle: 'Pretending to care',
            clipDate: new Date('2026-04-06T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '6701bc6c35797c2928318643',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/SparklingDifficultPheasantFutureMan-850CLGURlfH8KGcy',
            clipTitle: 'Adulting is a constant struggle',
            clipDate: new Date('2026-04-06T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '6701bc6c35797c2928318643',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/FuriousOpenCormorantFutureMan-N9F96F3tknnkArc5',
            clipTitle: 'Edgywizard, leader of the sheep',
            clipDate: new Date('2026-04-06T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '68016cb23f0914bff706b7ca',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/OddCovertRaccoonKevinTurtle-eaNdUf8T_Vq0nKeu',
            clipTitle: 'Poppy misses the political agreement',
            clipDate: new Date('2026-04-06T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '6701bc6c35797c2928318643',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/SpicyAverageRuffVoteYea-kN88ygmL8ZGWKPuH',
            clipTitle: "Stephen Hawking's Baked Alaska",
            clipDate: new Date('2026-04-06T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/daameer/clip/JazzySpookyEchidnaNomNom-1whjfhVIJuBpKiGg',
            clipTitle: "Kylie's sneaky cat-astrophic meme",
            clipDate: new Date('2026-04-06T00:00:00Z'),
            streamerName: 'daameer',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/daameer/clip/BlueHedonisticKangarooHotPokket-oSf5zYWTj_L0Yy3y',
            clipTitle: 'Big Bird knows global politics',
            clipDate: new Date('2026-04-06T00:00:00Z'),
            streamerName: 'daameer',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/daameer/clip/SpunkyCorrectClintmullinsBCWarrior-ZNr6FkAG3SliIQ9N',
            clipTitle: 'Loaded men with "heavy cargo"',
            clipDate: new Date('2026-04-06T00:00:00Z'),
            streamerName: 'daameer',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/daameer/clip/DistinctAssiduousShallotMingLee-FEiQIhxfmT0xPLGm',
            clipTitle: 'Pink Ostrich Runway',
            clipDate: new Date('2026-04-06T00:00:00Z'),
            streamerName: 'daameer',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/daameer/clip/OutstandingHumbleDootArsonNoSexy-VsLWTTHjsfUBge0c',
            clipTitle: 'War FTW & Kylieee sweet (but last)',
            clipDate: new Date('2026-04-06T00:00:00Z'),
            streamerName: 'daameer',
            gameId: '693bad642f3a8ff742190144',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/daameer/clip/SleepyRacyBeaverSaltBae-S8GR2Z9UTAJInkVt',
            clipTitle: 'Tiny Black tranquilized in bathtub',
            clipDate: new Date('2026-04-06T00:00:00Z'),
            streamerName: 'daameer',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/ProtectiveAttractivePartridgeImGlitch-nhQaop6ze1tBBxm-',
            clipTitle: 'Survival is the only goal',
            clipDate: new Date('2026-02-17T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '6701bc6c35797c2928318643',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/HonorableGoodAardvarkUnSane-NrcRV07z8YKYrWcm',
            clipTitle: 'Someone would actually serve that!',
            clipDate: new Date('2026-02-17T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/HotOnerousCrabsTebowing--ymRGomnCwPOCKmh',
            clipTitle: 'Unholy defiance of convention',
            clipDate: new Date('2026-02-17T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/SucculentTentativePangolinMcaT-Vq5BLYW0r3pJf2Qk',
            clipTitle: 'Some satisfaction knows no bounds',
            clipDate: new Date('2026-02-17T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/AbstruseSullenSquirrelUnSane-Kvb4-hV21hubPho4',
            clipTitle: 'Edgy broadens his horizons',
            clipDate: new Date('2026-02-17T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/HelplessPoorCucumberTinyFace-ZHJV4voQvLaq8uvK',
            clipTitle: 'Recession-proof assets',
            clipDate: new Date('2026-02-17T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/SteamyConfidentBaconM4xHeh-8r7hcA3Uwm8lHOSQ',
            clipTitle: 'Chat blows up after Edgy revealed',
            clipDate: new Date('2026-02-17T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '6921e33b0eef394c89845fb8',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/CleanAbstruseLemurMoreCowbell--xs1n8vWOYaqMJM8',
            clipTitle: 'Pleasure in Pain',
            clipDate: new Date('2026-02-17T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '693bad642f3a8ff742190144',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/MuddyCleverInternBlargNaut-J9QIvdD-Okjo0Oxf',
            clipTitle: 'Disastrous directions to safety',
            clipDate: new Date('2026-02-17T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '68016cb23f0914bff706b7ca',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/SpoopyScaryCiderSaltBae-pfy2X5Mcx-eRzox_',
            clipTitle: 'Quite the Sunday service',
            clipDate: new Date('2026-02-17T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/BoxyPolishedCookieImGlitch-I2iCL4sUfGFdq3tV',
            clipTitle: 'Certainly a mouthful',
            clipDate: new Date('2026-02-17T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/TriangularPlayfulCheetahTBTacoRight-QfpaFiaSICU8cXJL',
            clipTitle: "Dear lord - they're just little babies!",
            clipDate: new Date('2026-02-12T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/VastArtisticNuggetsTheRinger-3lemNJhZM0ujVUwq',
            clipTitle: 'Eat the rich',
            clipDate: new Date('2026-02-12T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/daameer/clip/ColdSleepyToothArgieB8-cpiSkrqCkrVL9Jz4',
            clipTitle: "Spotify's victory & Daameer's socks",
            clipDate: new Date('2026-02-02T00:00:00Z'),
            streamerName: 'daameer',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/daameer/clip/SassyWanderingBaconCmonBruh-ZYv-u03GOHot1reS',
            clipTitle: 'Poppy surprises Daameer with the news',
            clipDate: new Date('2026-02-02T00:00:00Z'),
            streamerName: 'daameer',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/daameer/clip/RenownedChillyLobsterPMSTwin-LV01UR3lFBA2Elp_',
            clipTitle: 'Seeking emotionally available human with bamboo',
            clipDate: new Date('2026-02-02T00:00:00Z'),
            streamerName: 'daameer',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/malachaihemet/clip/ViscousPlausibleCurryCmonBruh-yD-0Gs5E8cWWn9ld',
            clipTitle: 'Palke with big brain energy',
            clipDate: new Date('2026-01-27T00:00:00Z'),
            streamerName: 'MalachaiHemet',
            gameId: '693bad642f3a8ff742190144',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/malachaihemet/clip/BlatantVictoriousSpiderTinyFace-HbhHlHDfxEsztj0x',
            clipTitle: 'Gloriously uncomfortable',
            clipDate: new Date('2026-01-27T00:00:00Z'),
            streamerName: 'MalachaiHemet',
            gameId: '68016cb23f0914bff706b7ca',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/malachaihemet/clip/FamousPolishedTeaKreygasm-8pxv3VagpysFsHw-',
            clipTitle: 'Compassionate screaming in toilet',
            clipDate: new Date('2026-01-27T00:00:00Z'),
            streamerName: 'MalachaiHemet',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/malachaihemet/clip/TiredPoisedCrabsDendiFace-Xb7KVeXbiPYntL6g',
            clipTitle: 'Thriving on the blood of enemies',
            clipDate: new Date('2026-01-27T00:00:00Z'),
            streamerName: 'MalachaiHemet',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/the_beardedtavern/clip/FantasticCorrectGorillaPogChamp-l2qepYOsYKPbjMOY',
            clipTitle: 'Sensual humjob',
            clipDate: new Date('2026-01-27T00:00:00Z'),
            streamerName: 'the_beardedtavern',
            gameId: '6921e33b0eef394c89845fb8',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/the_beardedtavern/clip/TalentedTemperedShallotTriHard-GRfTudzbzicsltpI',
            clipTitle: 'Bad Docs BS to victory',
            clipDate: new Date('2026-01-27T00:00:00Z'),
            streamerName: 'the_beardedtavern',
            gameId: '6921e33b0eef394c89845fb8',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/malachaihemet/clip/ZanyBumblingPicklesBIRB-3nk81nGlRZTWOQif',
            clipTitle: 'Venom Talks Garbage',
            clipDate: new Date('2026-01-26T00:00:00Z'),
            streamerName: 'MalachaiHemet',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/malachaihemet/clip/SmokyLovelyMooseHotPokket-FJBZqX6Y4t0dJ_5H',
            clipTitle: 'Just vibing with grumpy cat',
            clipDate: new Date('2026-01-26T00:00:00Z'),
            streamerName: 'MalachaiHemet',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/malachaihemet/clip/CulturedStormyDiamondYouDontSay-bEpjTYXfyKiaewqd',
            clipTitle: 'Mal is the Meme Lord',
            clipDate: new Date('2026-01-26T00:00:00Z'),
            streamerName: 'MalachaiHemet',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/malachaihemet/clip/GiantStormyLeopardGrammarKing-57g17NpKfPoNwR4V',
            clipTitle: 'Me?! Nah...',
            clipDate: new Date('2026-01-26T00:00:00Z'),
            streamerName: 'MalachaiHemet',
            gameId: '6921e33b0eef394c89845fb8',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/malachaihemet/clip/VastSoftKaleSoBayed-apWI1DanLx2KjRoi',
            clipTitle: 'And the tiny trophy goes to... the good docs!',
            clipDate: new Date('2026-01-26T00:00:00Z'),
            streamerName: 'MalachaiHemet',
            gameId: '6921e33b0eef394c89845fb8',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/malachaihemet/clip/ArtisticMoldyCourgetteBleedPurple-Pg7QZ3kzTexftYy0',
            clipTitle: 'Pig Cheese Sour Cream',
            clipDate: new Date('2026-01-26T00:00:00Z'),
            streamerName: 'MalachaiHemet',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/malachaihemet/clip/ThirstyTenuousWoodpeckerWTRuck-y2m3mpjP3vpANlk7',
            clipTitle: 'Pineapple on the mind (and pizza)',
            clipDate: new Date('2026-01-26T00:00:00Z'),
            streamerName: 'MalachaiHemet',
            gameId: '6701bc6c35797c2928318643',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/AmericanSmokyLyrebirdAMPEnergy-Btk18RwWRhckUD4c',
            clipTitle: "Who's a good boy?",
            clipDate: new Date('2026-01-22T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/BoxyStrongStrawberryStoneLightning-_DmTZJjTQGxR1SxT',
            clipTitle: "Chef's kiss to the constitution",
            clipDate: new Date('2026-01-22T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/ThankfulReliablePepperRitzMitz-IVZ27zNoY2bNMpmj',
            clipTitle: 'Life size hot dog',
            clipDate: new Date('2026-01-22T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/FunnyPreciousNikudonHumbleLife-8mAnXxceOxGASlh5',
            clipTitle: 'Naughty and nice',
            clipDate: new Date('2026-01-22T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '6701bc6c35797c2928318643',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/DelightfulArtsyWalrusHotPokket-dJASH9-WNZjrdLPw',
            clipTitle: 'Leave those orifices be',
            clipDate: new Date('2026-01-22T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/ThirstyComfortableBisonBibleThump-xK0UFWnNDuUACvJB',
            clipTitle: 'High-octane romance',
            clipDate: new Date('2026-01-22T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/HumbleSmallChoughJKanStyle-nGJF3LvVPz0HbcNl',
            clipTitle: 'The moment my life peaked',
            clipDate: new Date('2026-01-21T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/BrainyAstuteHareGOWSkull-2emv-4luWBIqOdT9',
            clipTitle: 'Secure loose objects and children',
            clipDate: new Date('2026-01-21T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: false,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/SparklyFriendlyReindeerAsianGlow-BifLt9boWaZb09Wf',
            clipTitle: 'Cooking up true "happiness"',
            clipDate: new Date('2026-01-21T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/ClumsySmellyPassionfruitUnSane-CY4kAcAiopKqWuRc',
            clipTitle: 'It knows you lot!',
            clipDate: new Date('2026-01-21T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '693bad642f3a8ff742190144',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/TenderBashfulMacaroniArgieB8-96_kjYJNjvTtNQVZ',
            clipTitle: 'Take a chance on me',
            clipDate: new Date('2026-01-21T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '6921e33b0eef394c89845fb8',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/ProductiveObedientBottleCharlietheUnicorn-mo8X_VRfGw-HUUUm',
            clipTitle: "Edgy won't remember winning",
            clipDate: new Date('2026-01-21T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '68016cb23f0914bff706b7ca',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/VivaciousHomelyHeronDuDudu-0CzB3ALy4bP5q9Bz',
            clipTitle: 'A proper send-off',
            clipDate: new Date('2026-01-21T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/PeppyToughLEDArsonNoSexy-kHjBnBPPXGLEbNYy',
            clipTitle: "We'll need a bigger litterbox",
            clipDate: new Date('2026-01-21T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/edgywizard/clip/RichLightNewtDeIlluminati-Fz22A1GJNenhjyov',
            clipTitle: 'Exchanging gunfire mid-song',
            clipDate: new Date('2026-01-21T00:00:00Z'),
            streamerName: 'Edgywizard',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/TawdryLazyMageRiPepperonis-gBF81DRF96j1tNsD',
            clipTitle: 'Nasty Pig',
            clipDate: new Date('2026-01-21T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/SmokyEnticingRhinocerosSpicyBoy-WJ3XZu1uczfhm9dP',
            clipTitle: 'Creamy appetizer reveal',
            clipDate: new Date('2026-01-21T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/OutstandingBenevolentWasabiWow-oPWjxkifp0pvKbT4',
            clipTitle: 'Got a rise out of that BBQ',
            clipDate: new Date('2026-01-21T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/CleverUnsightlyKathyResidentSleeper-ijSwRxIK14_d0u1u',
            clipTitle: 'Best rap duo ever?',
            clipDate: new Date('2026-01-21T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '693bad642f3a8ff742190144',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/JazzyWealthyLarkSoBayed-lXVo9AsooAX4Ubzr',
            clipTitle: 'An Authentic Carnal Experience',
            clipDate: new Date('2026-01-21T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/VastExpensiveLapwingTBCheesePull-M1M2Dd2HTZC0tFKD',
            clipTitle: 'Corpse "disrespected"',
            clipDate: new Date('2026-01-21T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/chesstopia1/clip/FitHealthyHamsterTooSpicy-t2uVRvUlqDnqFRPV',
            clipTitle: 'When she asks about your size',
            clipDate: new Date('2026-01-20T00:00:00Z'),
            streamerName: 'Chesstopia1',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/chesstopia1/clip/GeniusLaconicSparrowJKanStyle-oAXx4ls5jxNN_ebS',
            clipTitle: 'Lena dominates men',
            clipDate: new Date('2026-01-20T00:00:00Z'),
            streamerName: 'Chesstopia1',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: true,
            downloaded: true,
            status: 'inactive',
        },
        {
            clipUrl: 'https://www.twitch.tv/chesstopia1/clip/FurtiveDarlingWallabyNomNom-WMlE5lGi1CQKVjDE',
            clipTitle: 'Massage with prickly cactus',
            clipDate: new Date('2026-01-20T00:00:00Z'),
            streamerName: 'Chesstopia1',
            gameId: '6921e33b0eef394c89845fb8',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/chesstopia1/clip/RoughRelentlessKoalaDuDudu-gRty641zL5gQg8fZ',
            clipTitle: 'What did he say about chess?!',
            clipDate: new Date('2026-01-20T00:00:00Z'),
            streamerName: 'Chesstopia1',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/chesstopia1/clip/KawaiiBombasticClipsdadNomNom-jyWmt0k1Bak6kybY',
            clipTitle: 'Enjoy some Lena now',
            clipDate: new Date('2026-01-20T00:00:00Z'),
            streamerName: 'Chesstopia1',
            gameId: '68016cb23f0914bff706b7ca',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/chesstopia1/clip/CloudyEnchantingPotPrimeMe-ETWXF6Xx002mKW20',
            clipTitle: 'no, nO, NO, NOOO, NOOOO!!!',
            clipDate: new Date('2026-01-20T00:00:00Z'),
            streamerName: 'Chesstopia1',
            gameId: '68016cb23f0914bff706b7ca',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/chesstopia1/clip/LongVastJayGOWSkull-j37ZRXnJTbObPAzP',
            clipTitle: 'Nut collecting 4-way tie',
            clipDate: new Date('2026-01-20T00:00:00Z'),
            streamerName: 'Chesstopia1',
            gameId: '68016cb23f0914bff706b7ca',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/chesstopia1/clip/TransparentAmorphousButterflySmoocherZ-mMJXkl6VqROEbheh',
            clipTitle: 'Someone has trust issues',
            clipDate: new Date('2026-01-20T00:00:00Z'),
            streamerName: 'Chesstopia1',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/chesstopia1/clip/PrettyFunnyWallabyPartyTime-LRM4L34qiVlkaMB8',
            clipTitle: 'Intik & Lena holding hands',
            clipDate: new Date('2026-01-20T00:00:00Z'),
            streamerName: 'Chesstopia1',
            gameId: '693bad642f3a8ff742190144',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/chesstopia1/clip/InnocentAffluentDurianSoBayed-l45svPvba25uGxtm',
            clipTitle: 'Solid D+ effort',
            clipDate: new Date('2026-01-20T00:00:00Z'),
            streamerName: 'Chesstopia1',
            gameId: '68016cb23f0914bff706b7ca',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/jolipollie/clip/PiliableEnchantingGrassDoggo-93u6wBCUKZcLaN_2',
            clipTitle: 'Uncle Barry was into some weird stuff',
            clipDate: new Date('2026-01-06T00:00:00Z'),
            streamerName: 'JoliPollie',
            gameId: '6701bc6c35797c2928318643',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/jolipollie/clip/ColdbloodedPoisedFloofANELE-D9VysEEbIPHf7eaD',
            clipTitle: 'Does Meg know a lot of cults?',
            clipDate: new Date('2026-01-06T00:00:00Z'),
            streamerName: 'JoliPollie',
            gameId: '693bad642f3a8ff742190144',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/jolipollie/clip/FurryObeseVampireImGlitch-Ljjhq_jJpX-6M9e3',
            clipTitle: 'Slay Divas',
            clipDate: new Date('2026-01-06T00:00:00Z'),
            streamerName: 'JoliPollie',
            gameId: '693bad642f3a8ff742190144',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/starlineovo/clip/CourteousCrypticThymeTheThing-f8Je_vaGk8g9UVj3',
            clipTitle: 'Leveling up my human :D',
            clipDate: new Date('2025-11-30T00:00:00Z'),
            streamerName: 'starlineovo',
            gameId: '6701bc6c35797c2928318643',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/starlineovo/clip/HonestPunchyJuicePogChamp-ReoGEEdZchBSGc33',
            clipTitle: "Who doesn't like naptime?",
            clipDate: new Date('2025-11-30T00:00:00Z'),
            streamerName: 'starlineovo',
            gameId: '6701bc6c35797c2928318643',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/the_beardedtavern/clip/CreativeRudeMushroomMingLee-GbZpfXMd9AWryV24',
            clipTitle: 'I just want to escape this tavern',
            clipDate: new Date('2025-11-30T00:00:00Z'),
            streamerName: 'the_beardedtavern',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/HonorableConsideratePotSSSsss-Bhk680Tb3gtor4kh',
            clipTitle: 'An experience so thoroughly immersive...',
            clipDate: new Date('2025-11-27T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/AmericanPrettyCobblerRitzMitz-F4VvsuTrmqbLsUDl',
            clipTitle: 'Some things penetrate deeper than others',
            clipDate: new Date('2025-11-27T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/ApatheticCallousChipmunkSaltBae-UklIpC3MTX4NytJj',
            clipTitle: 'Tom Brady Leaves Them Too Satisfied To Score',
            clipDate: new Date('2025-11-23T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/DullSoftCoyoteOptimizePrime-PM4g3H5WQxgzUFva',
            clipTitle: 'Too soon for a Diddy party?',
            clipDate: new Date('2025-11-23T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/doctordiggitydank/clip/GiftedFitBasenjiMcaT-LrfDubV91zNBkYiq',
            clipTitle: "Not surprised by Doc's fetish...",
            clipDate: new Date('2025-11-23T00:00:00Z'),
            streamerName: 'DoctorDiggityDank',
            gameId: '6701bc6c35797c2928318643',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/the_beardedtavern/clip/EmpathicFreezingPelicanKappaPride-yowl8x6_0_vXjXB3',
            clipTitle: "Nan: Don't watch the VOD",
            clipDate: new Date('2025-11-23T00:00:00Z'),
            streamerName: 'the_beardedtavern',
            gameId: '6701bc6c35797c2928318643',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/the_beardedtavern/clip/PerfectArtsyFriesImGlitch-DRdS1CucKF-R7Hn-',
            clipTitle: "The final award wasn't even close",
            clipDate: new Date('2025-11-23T00:00:00Z'),
            streamerName: 'the_beardedtavern',
            gameId: '68016cb23f0914bff706b7ca',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/the_beardedtavern/clip/FineNastyRingPastaThat-LEi_hvGyk4hSJsRB',
            clipTitle: 'Gabby has talent for liquid negotiations',
            clipDate: new Date('2025-11-23T00:00:00Z'),
            streamerName: 'the_beardedtavern',
            gameId: '68016cb23f0914bff706b7ca',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/chaosascends/clip/ScrumptiousSparklingLaptopPartyTime-iYTNt7VzudYnGq7F',
            clipTitle: 'Bad doctors... or everyone is evil?',
            clipDate: new Date('2026-01-14T00:00:00Z'),
            streamerName: 'ChaosAscends',
            gameId: '6921e33b0eef394c89845fb8',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/chaosascends/clip/EnergeticBlindingWaterMingLee-odtDL5X-mnp5QxQJ',
            clipTitle: 'Goodbye is the hardest word',
            clipDate: new Date('2026-01-14T00:00:00Z'),
            streamerName: 'ChaosAscends',
            gameId: '68016cb23f0914bff706b7ca',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/chaosascends/clip/DrabExcitedTaroSpicyBoy-4l-NR2dwnb1FHA0V',
            clipTitle: 'But... I lived in the woods!!',
            clipDate: new Date('2026-01-14T00:00:00Z'),
            streamerName: 'ChaosAscends',
            gameId: '68016cb23f0914bff706b7ca',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/chaosascends/clip/MushyArborealHorseradishOMGScoots-vLw0ktlup0Rwr_Cb',
            clipTitle: 'Ginger has gravitational pull',
            clipDate: new Date('2026-01-14T00:00:00Z'),
            streamerName: 'ChaosAscends',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/chaosascends/clip/DeafTolerantSoymilkPupper-1750s2CR2VtGB6E2',
            clipTitle: 'THE SHADE!!',
            clipDate: new Date('2026-01-14T00:00:00Z'),
            streamerName: 'ChaosAscends',
            gameId: '67d1c7c8d303f4b1017260a4',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/chaosascends/clip/LuckyCourageousBatteryStinkyCheese-sAlfDZiDXj6unCa4',
            clipTitle: 'Dark obituary headlines',
            clipDate: new Date('2026-01-14T00:00:00Z'),
            streamerName: 'ChaosAscends',
            gameId: '68eb1f40d63530c3bfd356e6',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/chaosascends/clip/TangibleSleepyWhaleMau5-PegiAQhQza3W1NL8',
            clipTitle: 'Flattr',
            clipDate: new Date('2026-01-14T00:00:00Z'),
            streamerName: 'ChaosAscends',
            gameId: '6701bc6c35797c2928318643',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/chaosascends/clip/EntertainingHyperDragonfruitDoubleRainbow-IaxeayFlMH6SVCAy',
            clipTitle: "Without a moment's hesitation",
            clipDate: new Date('2026-01-14T00:00:00Z'),
            streamerName: 'ChaosAscends',
            gameId: '6701bc6c35797c2928318643',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/chaosascends/clip/DoubtfulBadWaterSMOrc-3PGZDfnCqD1F2t_Z',
            clipTitle: 'Anarchy! Anarchy! Anarchy!',
            clipDate: new Date('2026-01-14T00:00:00Z'),
            streamerName: 'ChaosAscends',
            gameId: '693bad642f3a8ff742190144',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/chaosascends/clip/AmazonianThirstyDeerBrainSlug-cE2G_Kw0c7Zt1Ei1',
            clipTitle: 'Sounds like a fantastic meal',
            clipDate: new Date('2026-01-14T00:00:00Z'),
            streamerName: 'ChaosAscends',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
        {
            clipUrl: 'https://www.twitch.tv/chaosascends/clip/CarefulFuriousPuffinFailFish-TvLnHqPNLmASAOq5',
            clipTitle: 'This dish screams "Family Reunion"',
            clipDate: new Date('2026-01-14T00:00:00Z'),
            streamerName: 'ChaosAscends',
            gameId: '6944abab5d2f2d3fde971460',
            postedToSocial: true,
            downloaded: true,
            status: 'active',
        },
    ],
};
//# sourceMappingURL=clipLibrary.js.map